var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots"},[_vm._l((_vm.value),function(i){return _c('span',{staticClass:"dots-filled"})}),_vm._l((_vm.max - _vm.value),function(i){return _c('span',{staticClass:"dots-outlined"})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }